import loadPolyfills from 'bootstrap/entries/2-polyfill';

import 'bootstrap/publicPath';

import bootstrapApp from './bootstrap';

(async () => {
  await loadPolyfills();
  await bootstrapApp();
})();
